import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';

// components
import { Card, CardBody, Row, Col, Container, FormGroup, Form, Input, Button, Spinner } from "reactstrap";

// helpers
import { showMessage } from "../../helpers/message.js";
import { removeAllCookies, setSessionCookie } from "../../helpers/cookies.js";

// api
import usuario_api from "api/usuario_api.js";

export default function Login({ history }) {

    const { register, handleSubmit, setValue, clearErrors, errors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = React.useState(false);

    useEffect(() => {
        removeAllCookies();        
    }, []);

    const onSubmit = (data) => {
        let json_submit = {
            username: data.login,
            password: data.senha
        }

        setshowLoading(true);
        usuario_api.authenticate(json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else if (result.data == null) {
                showMessage("Aviso", "Usuário/Senha não encontrado", 'warning', null);
            }
            else {
                setSessionCookie(result.data);
                history.push("/admin/inicio");
            }
        });        
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }

            <Card style={{marginTop: "10vh"}}>
                <CardBody>
                    <Container>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Row className="mt-4 pl-4">
                                <Col lg="6" md="12" className="text-center">
                                    <h5>Bem Vindo ao FLIC!</h5>
                                    <label className="text-center">Sistema de Fiscalização Integrada de Concessões</label>
                                    <div className="mb-4">
                                        <img src={require("assets/img/logo.png")} className="img-logo" />
                                    </div>
                                </Col>
                                <Col lg="6" md="12" className="mb-4">
                                    <Row>
                                        <Col md="12">
                                            < Row>
                                                <Col md="12" lg="12">                                                     
                                                    <h5 className="text-center">Dados de Acesso</h5>
                                                    <FormGroup>
                                                        <label>Usuário</label>
                                                        <Input type="login" name="login" maxLength="200" innerRef={register({ required: true })} />
                                                        {errors.login && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <label>Senha</label>
                                                        <Input type="password" name="senha" maxLength="100" innerRef={register({ required: true })} />
                                                        {errors.senha && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                    </FormGroup>
                                                    <a style={{ cursor: "pointer" }} onClick={() => { history.push("/auth/esqueceusenha"); }}>Esqueci a senha</a>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <div className="text-right">
                                        <Button color="success" className="btn-mobile" type="submit">ENTRAR </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </Container>
                </CardBody>                
            </Card>            
        </>
    );
}